import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { isNotEmpty } from 'src/app/shared/functions/utils.functions';

@Component({
  selector: 'app-filters-group',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
  ],
  templateUrl: './filters-group.component.html',
  styleUrl: './filters-group.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersGroupComponent  implements AfterViewInit {
  @Input() title: string = '';
  @Input() form!: FormGroup;
  @Input() filtersGroup: Array<string> = [];

  filtersAppliedCount = signal(0);
  showFiltersAppliedCount = computed(() => this.filtersAppliedCount() !== 0)

  ngAfterViewInit(): void {
    this.form?.valueChanges.subscribe(() => {
      let count = 0;
      this.filtersGroup.forEach((field) => {
        if (isNotEmpty(this.form?.value[field])) {
          count++;
        }
      })
      this.filtersAppliedCount.set(count);
    })
  }
}
